import axios from 'axios';
import { resolveApiBaseUrl } from './apiOrigin';

/**
 * Central tenant registry under /api/v1/tenants (not /tenants).
 * /tenants is reserved for the React SPA page so reloads serve the UI, not JSON.
 */
const centralAxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

function isTenantRegistryRequest(url) {
  const path = String(url || '').split('?')[0];
  return path === '/tenants' || path.startsWith('/tenants/');
}

function getCurrentUiRoute() {
  if (typeof window === 'undefined' || !window.location) return null;
  const { pathname, search, hash } = window.location;
  return `${pathname || ''}${search || ''}${hash || ''}` || null;
}

centralAxiosInstance.interceptors.request.use(
  (config) => {
    config.baseURL = resolveApiBaseUrl();
    config.headers = config.headers || {};
    // Central tenant registry must not send X-TenantID.
    if (isTenantRegistryRequest(config.url)) {
      if (typeof config.headers.delete === 'function') {
        config.headers.delete('X-TenantID');
      } else {
        delete config.headers['X-TenantID'];
      }
    }
    if (!config.headers['X-UI-Route']) {
      const uiRoute = getCurrentUiRoute();
      if (uiRoute) {
        config.headers['X-UI-Route'] = uiRoute;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default centralAxiosInstance;
